import React from 'react';
import { getTrackLabel } from '@24i/player-utils-react';
import { useTheme } from '@24i/nxg-sdk-higgs/src/hooks/useTheme';
import { getFont } from '@24i/nxg-sdk-higgs/src/StyleSheet';
import { Container, Header, OptionsContainer } from './styled';
import { PlayerIcon } from '../../../../../Icons';
import { Button } from '../../../../../Button/styled';
import { Option } from './components/Option';
export const Options = ({ name, onBack, onSelect, options, selected, styles, }) => {
    var _a, _b;
    const { theme } = useTheme();
    const diffIds = {
        Audio: 'audio',
    };
    const settingType = (_a = diffIds[name]) !== null && _a !== void 0 ? _a : name.toLocaleLowerCase();
    return (React.createElement(Container, { style: styles.container, className: "Options", "data-test": "Options" },
        React.createElement(Header, { style: styles.header, className: "Options-Header", onClick: onBack },
            React.createElement(Button, { style: styles.backButton, className: "Options-BackButton", "data-test": "Options-BackButton", testID: "back_to_settings_button", backgroundColor: "transparent", onClick: onBack },
                React.createElement(PlayerIcon, { name: "onPrimary-back", style: Object.assign(Object.assign({}, styles.backIcon), { width: 24, height: 24, margin: '0 10px' }), className: "Options-icon" })),
            React.createElement("span", { style: Object.assign(Object.assign({ color: ((_b = theme === null || theme === void 0 ? void 0 : theme.color) === null || _b === void 0 ? void 0 : _b.textPrimary) || 'white' }, getFont(theme, 'h5')), (styles.title || {})), className: "Options-Name", "data-test": "Options-Name" }, name)),
        React.createElement(OptionsContainer, { className: "Options-Container", style: styles.optionsContainer }, options.map((option) => {
            var _a;
            const optionName = getTrackLabel(option, options);
            const optionSelected = selected ? option.id === selected.id : option.selected;
            return (React.createElement(Option, { styles: Object.assign({
                    optionTitle: Object.assign(Object.assign({}, getFont(theme, 'h5')), { color: ((_a = theme === null || theme === void 0 ? void 0 : theme.color) === null || _a === void 0 ? void 0 : _a.textPrimary) || 'white' }),
                }, styles.option), "data-test": "Option", testID: `${settingType}_${optionName}`, key: `Settings-${name}-${option.language}-${option.id}`, name: optionName, isActive: optionSelected, option: option, onClick: onSelect }));
        }))));
};
Options.defaultProps = {
    styles: {
        container: null,
        header: null,
        backButton: null,
        backIcon: null,
        title: null,
        option: {},
    },
};
//# sourceMappingURL=index.js.map